var gridIcon = "Icons-module_gridIcon__sbqYV";

export { gridIcon };
